//axios api
import pharmaGoodApi from "@/lib/PharmaGoodApi";

export const getAll = async () => {
  try {
    const queryRoute = `/admin/settings/promotion-calendar`;

    const fetchRes = pharmaGoodApi.axios.get(queryRoute);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
};

export const upsert = async (date, body) => {
  try {
    const queryRoute = `/admin/settings/promotion-calendar/${date}`;

    const fetchRes = pharmaGoodApi.axios.post(queryRoute, body);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
};

export const remove = async (date, body) => {
  try {
    const queryRoute = `/admin/settings/promotion-calendar/${date}`;

    const fetchRes = pharmaGoodApi.axios.delete(queryRoute, body);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
};
